import Box from '@classify/react-core-components/Box';
import SortableList from '@classify/react-core-components/SortableList';
import SortableListItem from '@classify/react-core-components/SortableListItem';

const COMPONENT_NAME = 'autocompleteSelections';

function getOnSortHandler(onSort) {
  return ({ orderedItems }) => {
    onSort(orderedItems.map(({ id, name }) => ({ id, value: name })));
  };
}

function renderItem(item, onRemove) {
  return (
    <span className="autocompleteSelections__item" key={item.id}>
      <span className="autocompleteSelections__itemValue">{item.value}</span>
      <button
        aria-label={`Remove ${item.value}`}
        className="autocompleteSelections__removeItem"
        onClick={onRemove}
        type="button"
      >
        <i className="icon-remove" />
      </button>
    </span>
  );
}

function renderNormalItems(items, getRemoveItemHandler) {
  return (
    <span className={COMPONENT_NAME}>
      {items.map((item) => renderItem(item, getRemoveItemHandler(item)))}
    </span>
  );
}

function renderSortableItems(items, getRemoveItemHandler, onSortProp) {
  const onSort = getOnSortHandler(onSortProp);

  return (
    <span className={`${COMPONENT_NAME} ${COMPONENT_NAME}--sortable`}>
      <SortableList onSortEnd={onSort}>
        {items.map((item) => (
          <SortableListItem key={item.id} itemData={{ name: item.value, id: item.id }}>
            <Box>{renderItem(item, getRemoveItemHandler(item))}</Box>
          </SortableListItem>
        ))}
      </SortableList>
    </span>
  );
}

function AutocompleteSelections({ onRemoveItem, items = [], sortable = false, onSort = () => {} }) {
  if (!items.length) {
    return null;
  }

  const getRemoveItemHandler = (item) => (e) => {
    e.preventDefault();
    onRemoveItem(item);
  };

  if (sortable) {
    return renderSortableItems(items, getRemoveItemHandler, onSort);
  }

  return renderNormalItems(items, getRemoveItemHandler);
}

export default AutocompleteSelections;
